var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconAsphalt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "#6f29a3",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m24.958 0.95996h-17.917c-3.3584 0-6.0816 2.7232-6.0816 6.0816v17.918c0 3.3584 2.7232 6.0816 6.0816 6.0816h17.918c3.3584 0 6.0816-2.7232 6.0816-6.0816v-17.918c0-3.3584-2.7232-6.0816-6.0816-6.0816zm-8.3072 25.81c0 0.3808-0.3088 0.6896-0.6896 0.6896s-0.6896-0.3088-0.6896-0.6896v-4.2992c0-0.3808 0.3088-0.6896 0.6896-0.6896s0.6896 0.3088 0.6896 0.6896zm0-8.6096c0 0.3808-0.3088 0.6896-0.6896 0.6896s-0.6896-0.3088-0.6896-0.6896v-4.3104c0-0.3808 0.3088-0.6896 0.6896-0.6896s0.6896 0.3088 0.6896 0.6896zm0-8.6192c0 0.3808-0.3088 0.68964-0.6896 0.68964s-0.6896-0.30884-0.6896-0.68964v-4.3104c0-0.3808 0.3088-0.6896 0.6896-0.6896s0.6896 0.3088 0.6896 0.6896z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAsphalt);
export default __webpack_public_path__ + "static/media/icon_asphalt.590f81a2d5387321eb21194b89aff8db.svg";
export { ForwardRef as ReactComponent };